import { connect } from "react-redux";
import { handleResp } from "shared/method";
import { getUser, logOut, updatePassword } from "store/actions/session";
import App from "./view";

const mapStateToProps = (state) => {
  return {
    user: state.session.user
  };
};

const mapDispatchToProps = (dispatch) => ({
  logOut: () => {
    dispatch(logOut());
  },
  getUser: async () => {
    return await handleResp(dispatch, getUser);
  },
  updatePassword: async (id, data) => {
    const params = {
      body: data,
      id
    };
    return await handleResp(undefined, updatePassword, params);
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
